module.exports = __webpack_public_path__ + "img/content5_400_15.7d443016.png";